import { render, staticRenderFns } from "./SettingsClientModal.vue?vue&type=template&id=48384ddb&lang=pug&"
import script from "./SettingsClientModal.vue?vue&type=script&lang=js&"
export * from "./SettingsClientModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports